import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { loadStripe, Stripe } from '@stripe/stripe-js';
import { BaseService } from 'app/services/base.service';
import { CoalService } from 'app/services/coal.service';
import { StripeService } from 'app/services/stripe.service';
import { MostrarSpinner, OcultarSpinner } from 'app/store/actions/utils.action';
import { AppState } from 'app/store/app.states';
import { environment } from 'environments/environment';

export interface DialogData {
    amount: number;
    folios: string;
    pof: string;
    precio: string;
    idpaquete: number;
    paquete: string;
    descripcion: string;
    cat_paquete: number;
    idEmpresa: number;
}

@Component({
    selector: 'app-stripe-charge',
    templateUrl: './stripe-charge.component.html',
    styleUrls: ['./stripe-charge.component.scss']
})
export class StripeChargeComponent implements OnInit {
    private stripe: Stripe;
    private payment: any;
    private cardNumber;
    private cardExpiry;
    private cardCvc;
    public token: any;
    private operacion;
    public rfc;
    public razonsocial;
    public dirfiscal;
    paymentStatus: string = ''; // 'success' o 'error'
    paymentMessage: string = ''; // Mensaje sobre el estado del pago

    style = {
        base: {
            iconColor: '#666EE8',
            color: '#31325F',
            lineHeight: '30px',
            fontWeight: 300,
            fontFamily: 'Helvetica Neue',
            fontSize: '15px',
            '::placeholder': {
                color: '#CFD7E0',
            },
        },
    };

    paymentElement: any;

    constructor(
        private stripes: StripeService,
        public dialogRef: MatDialogRef<StripeChargeComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
        private baseService: BaseService,
        private coalService: CoalService,
        private httpClient: HttpClient,
        private router: Router,
        private datePipe: DatePipe,
        private snackBar: MatSnackBar,
        private store: Store<AppState>
    ) { }

    async ngOnInit() {
        this.stripe = await loadStripe(environment.PublicStripeKey);
        const elements = this.stripe.elements({
            appearance: {
                theme: 'stripe',
                variables: {
                    colorPrimary: '#0570de',
                    colorBackground: '#ffffff',
                    colorText: '#30313d',
                    colorDanger: '#df1b41',
                    fontFamily: 'Ideal Sans, system-ui, sans-serif',
                    spacingUnit: '2px',
                    borderRadius: '4px',
                }
            }
        });

        this.cardNumber = elements.create('cardNumber', { placeholder: '' });
        this.cardNumber.mount('#card');

        this.cardExpiry = elements.create('cardExpiry', { placeholder: 'MM/AA' });
        this.cardExpiry.mount('#cardExpiry');

        this.cardCvc = elements.create('cardCvc', { placeholder: 'CVC' });
        this.cardCvc.mount('#cardCvc');

        this.operacion = this.baseService.getOperacionData();
        this.rfc = this.operacion?.empresaSeleccionada?.empresa?.attributes?.rfc;
        this.dirfiscal = this.operacion.Direccion;
        this.razonsocial = this.operacion?.empresaSeleccionada?.empresa?.attributes?.razonSocial;
    }

    async CreateToken() {
        var options = {};
        try {
            this.store.dispatch(MostrarSpinner());
            this.token = await this.stripe.createToken(this.cardNumber, options);
            if (this.token?.token?.id) {
                await this.insertPaquete();
            } else {
                this.showPaymentError(this.token?.error?.message || 'Error desconocido.');
            }
        } catch (error) {
            this.showPaymentError('Error procesando el pago. Revisa la información.');
        } finally {
            this.store.dispatch(OcultarSpinner());
        }
    }

    private async processPayment(packId) {
        try {
            let amount = this.data.amount * 100;
            this.payment = await this.stripes.ChargeStripe(this.token.token.id, amount, 'MXN', `Paquete ${this.data.folios} Folios`);
            if( this.payment.response.paid && this.payment.response.status == "succeeded" ){
                this.paymentStatus = 'success';
                this.paymentMessage = 'Pago exitoso. Gracias por tu compra.';
                this.updatePack(packId, 'Activo');
            }
            else{
                console.log(this.payment.error.raw.code)
                let errorStripe = 'El pago fue rechazado.';
                if(this.payment.error.raw.code ){
                    errorStripe = this.handleStripeError(this.payment.error.raw.code, '');
                }
                this.showPaymentError( errorStripe );
                this.store.dispatch(OcultarSpinner());
            }
            // if (Object.keys(this.payment.response).length > 0) {
                
            // } else {
                
            // }
        } catch (error) {
            this.store.dispatch(OcultarSpinner());
            this.showPaymentError('Error procesando el pago.');
        }
    }

    RestoreForm(){
        this.paymentStatus = '';
        this.paymentMessage = '';
        this.token = null;
        this.payment = null;

        // Desmontar elementos de Stripe si existen
        if (this.cardNumber) this.cardNumber.unmount();
        if (this.cardExpiry) this.cardExpiry.unmount();
        if (this.cardCvc) this.cardCvc.unmount();

        // Volver a montar los elementos de Stripe
        this.mountStripeElements();
        // this.dialogRef.close(0);
    }

    private async mountStripeElements() {
        try {
            const elements = this.stripe.elements({
                appearance: {
                    theme: 'stripe',
                    variables: {
                        colorPrimary: '#0570de',
                        colorBackground: '#ffffff',
                        colorText: '#30313d',
                        colorDanger: '#df1b41',
                        fontFamily: 'Ideal Sans, system-ui, sans-serif',
                        spacingUnit: '2px',
                        borderRadius: '4px',
                    }
                }
            });
    
            this.cardNumber = elements.create('cardNumber', { placeholder: '' });
            this.cardNumber.mount('#card');
    
            this.cardExpiry = elements.create('cardExpiry', { placeholder: 'MM/AA' });
            this.cardExpiry.mount('#cardExpiry');
    
            this.cardCvc = elements.create('cardCvc', { placeholder: 'CVC' });
            this.cardCvc.mount('#cardCvc');
        } catch (error) {
            console.error('Error mounting Stripe elements:', error);
        }
    }

    private showPaymentError(message: string) {
        this.paymentStatus = 'error';
        this.paymentMessage = message;
        this.snackBar.open(message, 'OK', { duration: 5000 });
    }

    async insertPaquete(){
        this.store.dispatch(MostrarSpinner());
        let parametros = {
            data: {
                folios: this.data.folios,
                precio: this.data.precio,
                paquete: this.data.paquete,
                descripcion: this.data.descripcion,
                cat_paquete: this.data.cat_paquete,
                idEmpresa: this.data.idEmpresa,
                status: status
            }
        };
        this.coalService.postService(`ope-empresa-paquetes`, parametros)
            .subscribe(
                async (res: any) => {
                    if (res.data) {
                        let packId = res.data.id;
                        await this.processPayment(packId);
                    }
                }, (error: any) => {
                    this.store.dispatch(OcultarSpinner());
                }
            );
    }

    updatePack(id, status) {
        let data = { data: { status } };
        this.coalService.putService(`ope-empresa-paquetes/status/${id}`, data)
            .subscribe((res: any) => {
                this.sedmail();
                this.router.navigate(['/cuenta/perfil'], { queryParams: { key: 'plan-billing' } });
                this.store.dispatch(OcultarSpinner());
                setTimeout(() => {
                    this.dialogRef.close(1);
                }, 5000);
            }, (error: any) => {
                this.store.dispatch(OcultarSpinner());
                this.snackBar.open('Ocurrió un error al actualizar el paquete', 'OK', { duration: 5000 });
            });
    }

    setResponseStripe(id) {
        let params = { data: { respuestaStripe: JSON.parse(JSON.stringify(this.payment)) } };
        this.coalService.putService(`ope-empresa-paquetes/${id}`, params).subscribe((res: any) => { });
    }

    sedmail() {
        let data = {
            from: '"Envio de Facturas "<testerebo@gmail.com>',
            correos: 'alex9abril@gmail.com',
            asunto: 'Compra Folios',
            cliente: this.operacion.razonSocial,
            folios: this.data.folios,
            amount: this.data.amount,
            fecha: this.datePipe.transform(new Date(), 'dd-MM-yyyy')
        };
        this.httpClient.post(environment.sparrowreport + 'EmailSender/SenMailCompraPaquete', data).subscribe(
            (data: any) => console.log('Correo enviado'),
            (error: any) => console.error(error)
        );
    }

    private handleStripeError(errorCode: string, defaultMessage: string) {
        let userMessage = '';
    
        switch (errorCode) {
            case 'amount_too_small':
                userMessage = 'El monto mínimo permitido es de $10.00 MXN.';
                break;
            case 'card_declined':
                userMessage = 'La tarjeta fue rechazada. Por favor, intenta con otra tarjeta.';
                break;
            case 'expired_card':
                userMessage = 'La tarjeta ha expirado. Verifica la fecha de vencimiento.';
                break;
            case 'invalid_cvc':
                userMessage = 'El código de seguridad (CVC) es incorrecto. Inténtalo de nuevo.';
                break;
            case 'processing_error':
                userMessage = 'Hubo un error procesando el pago. Inténtalo nuevamente más tarde.';
                break;
            default:
                userMessage = defaultMessage || 'Ocurrió un error desconocido.';
                break;
        }
    
        return userMessage;
    }
}
